import { queryOptions } from '@tanstack/vue-query'
import merge from 'lodash/merge'
import { queryClient } from '@/plugins/tanstack'
import { getSpaces } from '@/common/services/SpaceService'
import localizationItemServerData from '@/common/services/serverData/localizationItemServerData'
import { invalidateQuery, queryKeyFactory } from '@/common/services/serverData/serverDataManager'
import { SERVER_DATA_LABELS, SERVER_DATA_SCOPE, SERVER_DATA_TYPE, type GroupOptionsBase } from '@/common/types/cacheConstants'

function groupOptions(options: GroupOptionsBase = {}) {
  const defaultConfig = {
    queryKey: queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SPACES,
      type: SERVER_DATA_TYPE.LIST,
    }),
    staleTime: Infinity,
    queryFn: getSpaces,
  }
  return queryOptions(merge(defaultConfig, options))
}

async function fetch(options: GroupOptionsBase = {}) {
  const { staleTime } = options
  const [result] = await Promise.all([
    queryClient.fetchQuery(groupOptions(options)),
    localizationItemServerData.fetch({
      prefixes: SERVER_DATA_LABELS.SPACES,
      staleTime,
    }),
  ])
  return result
}

function invalidate() {
  invalidateQuery([
    queryKeyFactory({
      scope: SERVER_DATA_SCOPE.SPACES,
      type: SERVER_DATA_TYPE.LIST,
    }),
  ])
}

export default {
  fetch,
  groupOptions,
  invalidate,
}
